<div class="container_width flex flex-column gap-6">
  <div class=" flex flex-column bg-white shadow-1">
    <div class="w-full relative">
      <!--TODO: Image-->
      <p-image [src]="institute?.image || '../../../assets/images/college.jpg'" alt="Image" class="w-full block"
        imageClass="uniphoto" styleClass="uniphotoCon">
      </p-image>
      <div class="w-full flex align-items-center gap-1 absolute left-0 bottom-0">
        <a (click)="setProgramType('Bachelor\'s Degree')"
          [ngClass]="{'bg-white': selectedProgramType === 'Bachelor\'s Degree'}"
          class="bg-gray-200 w-auto inline-block hover:bg-white px-2 sm:px-4 cursor-pointer"
          style="padding-top: 12px; padding-bottom: 12px;">
          Undergraduate
        </a>
        <!-- <a (click)="setProgramType('Master\'s Degree')" class="bg-gray-200 w-auto inline-block hover:bg-white px-2 sm:px-4" style="padding-top: 12px; padding-bottom: 12px;" >Graduate</a> -->
        <a (click)="setProgramType('Master\'s Degree')"
          [ngClass]="{'bg-white': selectedProgramType === 'Master\'s Degree'}"
          class="bg-gray-200 w-auto inline-block hover:bg-white px-2 sm:px-4 cursor-pointer" style="padding: 12px 0;">
          Masters
        </a>

        <a [ngClass]="{'bg-white': displayCourses === true}" 
        (click)="displayCoursesTab()" class="bg-gray-200 w-auto inline-block hover:bg-white px-2 sm:px-4 cursor-pointer" style="padding: 12px 0;">
            Courses
        </a>

        <!-- <a [ngClass]="{'bg-white': selectedProgramType === 'Alumni'}" 
        (click)="setProgramType('Alumni')" class="bg-gray-200 w-auto inline-block hover:bg-white px-2 sm:px-4 cursor-pointer" style="padding: 12px 0;">
            Alumni
        </a> -->
      </div>
    </div>
    <div class="flex justify-content-between bg-white align-items-center gap-2 p-3 sm:p-4">
      <div class="flex flex-column gap-2">
        <h1 class="text-2xl sm:text-3xl font-medium">{{institute?.name??''}}</h1>
        <div class="flex align-items-center gap-2 sm:gap-3">
          <b class="flex align-items-center gap-2 font-normal text-base font-semibold sm:text-base text-bluegray-600">
            <i class="pi pi-map-marker"></i>
            {{ (institute?.cityName ? institute?.cityName : '') + (institute?.cityName && institute?.countryName ? ', ' : '') +
            (institute?.countryName ? institute?.countryName : '') }}
          </b>
          <!--TODO: Collage Old-->
          <!-- <i class="pi pi-circle-on text-bluegray-600" style="font-size: 6px;"></i>
          <b class="inline-block font-normal text-bluegray-600 text-base font-semibold sm:text-base">4 Year</b> -->
        </div>
      </div>
      <!-- <div *ngIf="portal === 'student'" class="w-auto">
        <p-checkbox  [binary]="true" [(ngModel)]="isMyInstitute" label="Add to list" name="Add to list"
          value="Add to list" styleClass="addlist" (onChange)="toggleMyInstitute(institute?.id ?? '')"
          labelStyleClass="add_list" />
      </div> -->
    </div>
  </div>

  <div *ngIf="!displayCourses" class="w-full flex gap-5 align-items-start">
    <div *ngIf="selectedProgramType !== 'Alumni'" class="w-16rem hidden lg:block">
      <ul class="w-full flex flex-column gap-3">
        <li>
          <a (click)="scrollToElement('divAbout')"
            class="w-full block text-left font-normal text-base text-color-secondary hover:text-primary cursor-pointer">About</a>
        </li>
        <li>
          <a (click)="scrollToElement('divRankings')"
            class="w-full block text-left font-normal text-base text-color-secondary hover:text-primary cursor-pointer">Rankings</a>
        </li>
        <li>
          <a (click)="scrollToElement('divAdmissions')"
            class="w-full block text-left font-normal text-base text-color-secondary hover:text-primary cursor-pointer">Admissions</a>
        </li>
        <li>
          <a (click)="scrollToElement('divCost')"
            class="w-full block text-left font-normal text-base text-color-secondary hover:text-primary cursor-pointer">Cost</a>
        </li>
        <li>
          <a (click)="scrollToElement('divScholarship')"
            class="w-full block text-left font-normal text-base text-color-secondary hover:text-primary cursor-pointer">Scholarship</a>
        </li>
        <li>
          <a (click)="scrollToElement('divStudents')"
            class="w-full block text-left font-normal text-base text-color-secondary hover:text-primary cursor-pointer">Students</a>
        </li>
        <li>
          <a (click)="scrollToElement('divAcademics')"
            class="w-full block text-left font-normal text-base text-color-secondary hover:text-primary cursor-pointer">Academics</a>
        </li>
        <li>
          <a (click)="scrollToElement('divMajors')"
            class="w-full block text-left font-normal text-base text-color-secondary hover:text-primary cursor-pointer">Majors</a>
        </li>
        <li>
          <a (click)="scrollToElement('divAfterCollege')"
            class="w-full block text-left font-normal text-base text-color-secondary hover:text-primary cursor-pointer">After
            College</a>
        </li>
        <li>
          <a (click)="scrollToElement('divSimilarCollege')"
            class="w-full block text-left font-normal text-base text-color-secondary hover:text-primary cursor-pointer">Similar
            College</a>
        </li>
      </ul>
    </div>
    <div class="w-full flex flex-column gap-3">
      <div *ngIf="selectedProgramType !== 'Alumni'" class="w-full flex flex-column gap-3">
        <div *ngIf="institute?.missionStatement" id="divAbout"
          class="w-full flex p-3 border-1 border-300 border-round-lg align-items-center">
          <p class="font-normal text-indigo-900 text-lg font-semibold text-left line-height-2">{{ institute?.missionStatement || '' }}
          </p>
        </div>

        <div class="w-full flex flex-column gap-3">
          <div class="w-full flex flex-column border-1 border-300 border-round-lg align-items-center py-3">
            <div class="w-full grid align-items-center ">
              <div class="col-12 md:col-6 grid px-2 md:px-0 pt-4 md:pt-0">
                <div class="col-6 flex flex-column gap-2 align-items-center">
                  <span
                    class="w-3rem text-white font-bold text-3xl h-3rem flex align-items-center justify-content-center border-circle"
                    style="background-color: #000086;">
                    {{institute?.branchCampuses}}
                  </span>
                  <b class="block text-center font-bold text-base">Branches</b>
                </div>
                <div class="col-6 flex flex-column gap-2 align-items-center">
                  <span class="w-3rem block">
                    <img src="../../../assets/icons/university_icon.svg" alt="" class="block w-full">
                  </span>
                  <b class="block text-center font-bold text-base"> {{institute?.controlOfInstitution}}</b>
                </div>
                <div class="col-6 flex flex-column gap-2 align-items-center">
                  <span class="w-3rem block">
                    <img src="../../../assets/icons/city_icon.svg" alt="" class="block w-full">
                  </span>
                  <b class="block text-center font-bold text-base">{{institute?.cityName}}</b>
                </div>
                <div class="col-6 flex flex-column gap-2 align-items-center">
                  <span class="w-3rem block">
                    <img src="../../../assets/icons/medium_icon.svg" alt="" class="block w-full">
                  </span>
                  <b class="block text-center font-bold text-base">{{institute?.degreeOfUrbanization}}</b>
                </div>
              </div>
              <div class="col-12 md:col-6 flex flex-column gap-2 px-4 md:px-0">
                <div #mapContainer class="w-full h-14rem bg-blue-400">
                  <!-- [height]="260" [width]="592" -->
                  <google-map [zoom]="15" [height]="mapHeight" [width]="mapWidth" [center]="center" >
                    <map-marker [position]="center"></map-marker>
                  </google-map>
                </div>
                <div
                  class="w-full flex-column gap-2 sm:flex-row flex align-items-start sm:align-items-center justify-content-between">
                  <b class="w-auto inline-flex align-items-center gap-2 font-normal" style="color: #565656;">
                    <i class="pi pi-map-marker"></i>
                    {{institute?.name}}
                  </b>
                  <a class="inline-flex align-items-center gap-2 cursor-pointer font-normal hover:underline"
                    style="color: #000086;">View on map <i class="pi pi-external-link text-base font-semibold"></i></a>
                </div>
              </div>
            </div>
          </div>

          <div class="w-full flex flex-column border-1 border-300 border-round-lg align-items-center">
            <div class="w-full flex-column md:flex-row p-4 flex gap-3">
              <div class="grid w-full">
                <div class="col-12 md:col-6 flex align-items-start gap-1 ">
                  <b class="font-medium flex align-items-center gap-2" style="color: #3B506C;">
                    <i class="flex-shrink-0" style="width: 24px;">
                      <img src="../../../assets/icons/web.svg" alt="" class="w-full block">
                    </i> Website</b>
                  <a *ngIf="institute?.webSite" target="_blank" 
                    [href]="getFullWebsiteURL(institute?.webSite ?? '')"
                    class="text-indigo-900 font-semibold hover:text-blue-500" style="line-height: 24px;">:
                    {{institute?.webSite}}</a>
                </div>
                <div class="col-12 md:col-6 flex align-items-start gap-1 ">
                  <b class="font-medium flex align-items-center gap-2" style="color: #3B506C;">
                    <i class="flex-shrink-0" style="width: 24px;">
                      <img src="../../../assets/icons/address.svg" alt="" class="w-full block">
                    </i>
                    Address</b>
                  <p *ngIf="institute?.address" class="text-indigo-900 font-semibold" style="line-height: 24px;">:
                    {{institute?.address+', '+institute?.cityName+', '+institute?.countryName}}</p>
                </div>
                <div class="col-12 md:col-6 flex align-items-center gap-1">
                  <b class="font-medium flex align-items-center gap-2" style="color: #3B506C;">
                    <i class="flex-shrink-0" style="width: 24px;">
                      <img src="../../../assets/icons/urban.svg" alt="" class="w-full block">
                    </i>
                    Urbanization</b>
                  <p class="text-indigo-900 font-semibold" style="line-height: 24px;">{{institute?.degreeOfUrbanization}}</p>
                </div>
                <div class="col-12 md:col-6 flex align-items-center gap-1">
                  <b class="font-medium flex align-items-center gap-2" style="color: #3B506C;">
                    <i class="flex-shrink-0" style="width: 24px;">
                      <img src="../../../assets/icons/city.svg" alt="" class="w-full block">
                    </i>
                    City</b>
                  <p class="text-indigo-900 font-semibold" style="line-height: 24px;">: {{institute?.cityName}}</p>
                </div>
                <div class="col-12 md:col-6 flex align-items-center gap-1">
                  <b class="font-medium flex align-items-center gap-2" style="color: #3B506C;">
                    <i class="flex-shrink-0" style="width: 24px;">
                      <img src="../../../assets/icons/state.svg" alt="" class="w-full block">
                    </i>Country</b>
                  <p class="text-indigo-900 font-semibold" style="line-height: 24px;">: {{institute?.countryName}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="w-full flex flex-column border-1 border-300 border-round-lg align-items-center">
        <div class="w-full flex-column p-4 flex gap-3">
          <h2 class="text-left font-medium text-xl" style="color: #000086;">Rankings</h2>
          <div class="grid align-items-start">
            <div class="col-12 sm:col-4 flex flex-column gap-1 ">
              <p class="font-medium text-base text-bluegray-600">QS World Ranking </p>
              <b class="font-semibold text-xl">#{{institute?.qsRanking}}</b>
            </div>
            <div class="col-12 sm:col-4 flex flex-column gap-1">
              <p class="font-medium text-base text-bluegray-600">US Ranking</p>
              <b class="font-semibold text-xl">#{{institute?.countryRanking}} of totalInstituteInCountry</b>
            </div>
            <div class="col-12 sm:col-4 flex flex-column gap-1 ">
              <p class="font-medium text-base text-bluegray-600">Subject Rank (BBA)</p>
              <b class="font-semibold text-xl">#{{institute?.qsRanking}}</b>
            </div>
          </div>
        </div>
      </div> -->
      <app-institute-detail-us (requestDisplayCourses)="displayCoursesTab()" *ngIf="institute?.countryCode === 'US'" [instituteUGMDetails]="instituteUGMDetails" [selectedProgramType]="selectedProgramType" [institute]="institute"></app-institute-detail-us>
      <app-institute-detail-uk (requestDisplayCourses)="displayCoursesTab()" *ngIf="institute?.countryCode === 'GB'" [instituteUGMDetails]="instituteUGMDetails" [selectedProgramType]="selectedProgramType" [institute]="institute"></app-institute-detail-uk>
      <app-institute-detail-in (requestDisplayCourses)="displayCoursesTab()" *ngIf="institute?.countryCode === 'IN'" [instituteUGMDetails]="instituteUGMDetails" [selectedProgramType]="selectedProgramType" [institute]="institute"></app-institute-detail-in>
      <app-institute-detail-au (requestDisplayCourses)="displayCoursesTab()" *ngIf="institute?.countryCode === 'AU'" [instituteUGMDetails]="instituteUGMDetails" [selectedProgramType]="selectedProgramType" [institute]="institute"></app-institute-detail-au>

      <div *ngIf="selectedProgramType !== 'Alumni'" id="divSimilarCollege"
        class="w-full flex flex-column border-1 border-300 border-round-lg align-items-center">
        <div class="flex flex-column gap-4 w-full p-4">
          <h2 class="text-left text-xl font-medium" style="color: #000086;">Similar Colleges</h2>
          <div class="grid">
            @for (item of similarInstitutes; track item) {
            <div class="col-12 lg:col-6">
              <div
                class="flex align-items-center justify-content-between gap-2 p-2 border-1 border-300 border-round-lg">
                <div class="flex align-items-center gap-2">
                  <span
                    class="flex align-items-center justify-content-center w-3rem h-3rem bg-yellow-400 border-circle overflow-hidden flex-shrink-0 flex-grow-0">
                    <img [src]="item?.logo ? item?.logo : '../../../assets/images/logo-placeholder.png'" alt=""
                      style="height: 100%; width: 100%; object-fit: cover; display: block;">
                  </span>
                  <div class="flex flex-column gap-1">
                    <b class="font-medium text-lg">{{item?.instituteName}}</b>
                    <p class="text-base font-semibold font-regular text-bluegray-500">{{ (item?.city ? item?.city : '') +
                      (item?.city && item?.country ? ', ' : '') +
                      (item?.country ? item?.country : '') }}</p>
                  </div>
                </div>
                <a [routerLink]="['/portal',item.id,'institute']"
                  class="w-auto text-base font-semibold hover:bg-blue-700 hover:text-white flex-shrink-0"
                  style="padding: 10px 16px; background-color: #CDD12A; color: #12263F; border-radius: 6px;">View
                  Detail</a>
              </div>
            </div>
            }
          </div>

        </div>
      </div>


    </div>

  </div>


  <!---Study Options-->

  <div *ngIf="displayCourses" class="w-full flex flex-column border-1 border-300 border-round-lg align-items-center">
    <div class="flex flex-column gap-3 w-full p-4">
      <h2 class="text-left text-xl font-medium" style="color: #000086;">Browse by Study Options</h2>
      <div class="w-full flex flex-column gap-3">
            <div class="w-full grid grid-nogutter">
              <div class="col-4 flex flex-column gap-2">
                <h2 class="text-left text-base font-regular" style="color: #3B506C; font-weight: 400;">Undergraduate</h2>
                <div class="w-full flex flex-column gap-2">
                  <div class="w-full flex flex-column gap-1 p-3 border-round-lg" style="background-color: #EDF5FF;">
                    <b class="w-full block text-left" style="text-transform: uppercase; font-size: 13px; color: #707070;">FULL TIME</b>
                    <h2 class="text-left text-xl font-medium" style="color: #000;">{{coursesCount?.bachelorsDegreeCoursesCount}} Courses</h2>
                  </div>
                </div>
              </div>
              <div class="col-4 px-2 flex flex-column gap-2">
                <h2 class="text-left text-base font-regular" style="color: #3B506C; font-weight: 400;">Masters</h2>
                <div class="w-full flex flex-column gap-2">
                  <div class="w-full flex flex-column gap-1 p-3 border-round-lg" style="background-color: #EDF5FF;">
                    <b class="w-full block text-left" style="text-transform: uppercase; font-size: 13px; color: #707070;">FULL TIME</b>
                    <h2 class="text-left text-xl font-medium" style="color: #000;">{{coursesCount?.mastersDegreeCourseCount}} Courses</h2>
                  </div>
                </div>
              </div>
              <div class="col-4 flex flex-column gap-2">
                <h2 class="text-left text-base font-regular" style="color: #3B506C; font-weight: 400;">Doctoral</h2>
                <div class="w-full flex flex-column gap-2">
                  <div class="w-full flex flex-column gap-1 p-3 border-round-lg" style="background-color: #EDF5FF;">
                    <b class="w-full block text-left" style="text-transform: uppercase; font-size: 13px; color: #707070;">FULL TIME</b>
                    <h2 class="text-left text-xl font-medium" style="color: #000;">{{coursesCount?.doctoralDegreeCoursesCount}} Courses</h2>
                  </div>
                </div>
              </div>
            </div>

          <div class="w-full flex flex-column gap-2 p-3 border-round-lg " style="background-color: #EDF5FF;">
            <h2 class="text-left text-lg font-medium" style="color: #202020;">Undergraduate</h2>
            <p-accordion class="w-full">
              @for (item of visibleUGCourses; track $index) {
                <p-accordionTab [header]="item.courseName ?? ''" iconPos="end" headerStyleClass="header_tab2" contentStyleClass="tab_content2">
                  <div class="w-full p-2 border-round-lg flex flex-column gap-2"
                    style="background-color: #EDF5FF; border: 1px solid #D8E2F0;">
                    <h2 class="w-full px-1 pt-2 text-left text-lg" style="color: #12263F;">
                      <a [href]="getFullWebsiteURL(item.courseUrl ?? '')" target="_blank" rel="noopener" class="hover:underline" style="color: #1E75E1;">{{item.courseName}} <i class="pi pi-arrow-up-right"></i></a>
                    </h2>
                    <div class="w-full grid grid-nogutter">
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Course Level</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.courseLevel || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Course URL</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">
                            <a *ngIf="item.courseUrl" [href]="getFullWebsiteURL(item.courseUrl)" target="_blank" rel="noopener" class="hover:underline" style="color: #1E75E1;">Visit Course Page <i class="pi pi-arrow-up-right"></i></a>
                            <span *ngIf="!item.courseUrl">N/A</span>
                          </h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode !== 'US'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Course Short Form</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.courseShortForm || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Start Date</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ item.startDate ? (item.startDate | date:'MMM dd/yyyy') : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode !== 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Major / Stream</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ (item.majorOrStream && item.majorOrStream.length) ? item.majorOrStream.join(', ') : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Study Mode</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.mode || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Duration</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ item.duration ? item.duration + ' years' : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Fee</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ item.courseFees ? (item.courseFees | currency: getCourseCurrencyCode(item.currency) : 'symbol' : '1.0-0') : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Eligibility Req</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.eligibilityRequirement || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="item.englishLanguageRequirement" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">English Language Req</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.englishLanguageRequirement}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'GB'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings post-graduation</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.medianEarningPostGraduation === '' || null ? 'N/A' : item.medianEarningPostGraduation | currency: 'GBP' : 'symbol' : '1.0-0' : 'en-GB'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings post-graduation</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.medianEarningPostGraduation === '' || null ? 'N/A' : item.medianEarningPostGraduation | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings Of Graduates Post 5 Years</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.workingGraduatesMedianEarningsNotEnrolledPost5YearsCompleting === '' || null ? 'N/A' : item.workingGraduatesMedianEarningsNotEnrolledPost5YearsCompleting | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Hostel & Living Expenses</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.hostelAndLivingExpenses === '' || null ? 'N/A' : item.hostelAndLivingExpenses | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'}}</h2>
                        </div>
                      </div>
                      
                      <!-- <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings post-graduation</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.medianEarningPostGraduation || 'N/A'}}</h2>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </p-accordionTab>
              }

            </p-accordion>
            <div class="mt-2 flex justify-content-end">
              <button class="px-4 py-2 text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                      (click)="toggleUGCoursesView()">
                {{ showAllUGCourses ? 'Show Less' : 'View All Courses' }}
              </button>
            </div>
          </div>

          <div class="w-full flex flex-column gap-2 p-3 border-round-lg " style="background-color: #EDF5FF;">
            <h2 class="text-left text-lg font-medium" style="color: #202020;">Masters</h2>
            <p-accordion class="w-full">
              @for (item of visiblePGCourses; track $index) {
                <p-accordionTab [header]="item.courseName ?? ''" iconPos="end" headerStyleClass="header_tab2" contentStyleClass="tab_content2">
                  <div class="w-full p-2 border-round-lg flex flex-column gap-2"
                    style="background-color: #EDF5FF; border: 1px solid #D8E2F0;">
                    <h2 class="w-full px-1 pt-2 text-left text-lg" style="color: #12263F;">
                      <a [href]="getFullWebsiteURL(item.courseUrl ?? '')" target="_blank" rel="noopener" class="hover:underline" style="color: #1E75E1;">{{item.courseName}} <i class="pi pi-arrow-up-right"></i></a>
                    </h2>
                    <div class="w-full grid grid-nogutter">
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Course Level</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.courseLevel || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Course URL</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">
                            <a *ngIf="item.courseUrl" [href]="getFullWebsiteURL(item.courseUrl)" target="_blank" rel="noopener" class="hover:underline" style="color: #1E75E1;">Visit Course Page <i class="pi pi-arrow-up-right"></i></a>
                            <span *ngIf="!item.courseUrl">N/A</span>
                          </h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode !== 'US'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Course Short Form</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.courseShortForm || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Start Date</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ item.startDate ? (item.startDate | date:'MMM dd/yyyy') : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode !== 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Major / Stream</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ (item.majorOrStream && item.majorOrStream.length) ? item.majorOrStream.join(', ') : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Study Mode</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.mode || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Duration</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ item.duration ? item.duration + ' years' : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Fee</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ item.courseFees ? (item.courseFees | currency: getCourseCurrencyCode(item.currency) : 'symbol' : '1.0-0') : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Eligibility Req</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.eligibilityRequirement || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="item.englishLanguageRequirement" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">English Language Req</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.englishLanguageRequirement}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'GB'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings post-graduation</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.medianEarningPostGraduation === '' || null ? 'N/A' : item.medianEarningPostGraduation | currency: 'GBP' : 'symbol' : '1.0-0' : 'en-GB'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings post-graduation</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.medianEarningPostGraduation === '' || null ? 'N/A' : item.medianEarningPostGraduation | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings Of Graduates Post 5 Years</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.workingGraduatesMedianEarningsNotEnrolledPost5YearsCompleting === '' || null ? 'N/A' : item.workingGraduatesMedianEarningsNotEnrolledPost5YearsCompleting | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Hostel & Living Expenses</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.hostelAndLivingExpenses === '' || null ? 'N/A' : item.hostelAndLivingExpenses | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'}}</h2>
                        </div>
                      </div>
                      
                      <!-- <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings post-graduation</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.medianEarningPostGraduation || 'N/A'}}</h2>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </p-accordionTab>
              }
              <div class="mt-2 flex justify-content-end">
                <button class="px-4 py-2 text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                        (click)="togglePGCoursesView()">
                  {{ showAllPGCourses ? 'Show Less' : 'View All Courses' }}
                </button>
              </div>
          </p-accordion>
          </div>

          <div class="w-full flex flex-column gap-2 p-3 border-round-lg " style="background-color: #EDF5FF;">
            <h2 class="text-left text-lg font-medium" style="color: #202020;">Doctoral</h2>
            <p-accordion class="w-full">
              @for (item of visibleDoctoralCourses; track $index) {
                <p-accordionTab [header]="item.courseName ?? ''" iconPos="end" headerStyleClass="header_tab2" contentStyleClass="tab_content2">
                  <div class="w-full p-2 border-round-lg flex flex-column gap-2"
                    style="background-color: #EDF5FF; border: 1px solid #D8E2F0;">
                    <h2 class="w-full px-1 pt-2 text-left text-lg" style="color: #12263F;">
                      <a [href]="getFullWebsiteURL(item.courseUrl ?? '')" target="_blank" rel="noopener" class="hover:underline" style="color: #1E75E1;">{{item.courseName}} <i class="pi pi-arrow-up-right"></i></a>
                    </h2>
                    <div class="w-full grid grid-nogutter">
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Course Level</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.courseLevel || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Course URL</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">
                            <a *ngIf="item.courseUrl" [href]="getFullWebsiteURL(item.courseUrl)" target="_blank" rel="noopener" class="hover:underline" style="color: #1E75E1;">Visit Course Page <i class="pi pi-arrow-up-right"></i></a>
                            <span *ngIf="!item.courseUrl">N/A</span>
                          </h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode !== 'US'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Course Short Form</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.courseShortForm || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Start Date</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ item.startDate ? (item.startDate | date:'MMM dd/yyyy') : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode !== 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Major / Stream</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ (item.majorOrStream && item.majorOrStream.length) ? item.majorOrStream.join(', ') : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Study Mode</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.mode || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Duration</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ item.duration ? item.duration + ' years' : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Fee</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{ item.courseFees ? (item.courseFees | currency: getCourseCurrencyCode(item.currency) : 'symbol' : '1.0-0') : 'N/A' }}</h2>
                        </div>
                      </div>
                      <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Eligibility Req</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.eligibilityRequirement || 'N/A'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="item.englishLanguageRequirement" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">English Language Req</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.englishLanguageRequirement}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'GB'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings post-graduation</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.medianEarningPostGraduation === '' || null ? 'N/A' : item.medianEarningPostGraduation | currency: 'GBP' : 'symbol' : '1.0-0' : 'en-GB'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings post-graduation</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.medianEarningPostGraduation === '' || null ? 'N/A' : item.medianEarningPostGraduation | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings Of Graduates Post 5 Years</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.workingGraduatesMedianEarningsNotEnrolledPost5YearsCompleting === '' || null ? 'N/A' : item.workingGraduatesMedianEarningsNotEnrolledPost5YearsCompleting | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'}}</h2>
                        </div>
                      </div>
                      <div *ngIf="institute?.countryCode === 'IN'" class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Hostel & Living Expenses</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.hostelAndLivingExpenses === '' || null ? 'N/A' : item.hostelAndLivingExpenses | currency: 'INR' : 'symbol' : '1.0-0' : 'en-IN'}}</h2>
                        </div>
                      </div>
                      
                      <!-- <div class="sm:col-6 col-12 p-1">
                        <div class="w-full flex flex-column gap-1 p-3 border-round-lg"
                          style="background-color: #fff; border: 1px solid #D8E2F0;">
                          <p style="color: #3B506C;">Median Earnings post-graduation</p>
                          <h2 class="text-left font-bold text-base" style="color: #12263F;">{{item.medianEarningPostGraduation || 'N/A'}}</h2>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </p-accordionTab>
              }
              <div class="mt-2 flex justify-content-end">
                <button class="px-4 py-2 text-base font-semibold border-none border-round cursor-pointer hover:underline text-blue-600 bg-transparent"
                        (click)="toggleDoctoralCoursesView()">
                  {{ showAllDoctoralCourses ? 'Show Less' : 'View All Courses' }}
                </button>
              </div>
          </p-accordion>
          </div>
      </div>
  </div>
 </div>

